<template>
  <div>
    <b-container v-if="!_.isEmpty(rata)">
      <b-row align-v="center" align-h="center" class="mb-4">
        <b-col lg="9">

          <template v-if="utilityType == 'Gas'">
            <h2 class="h3-semibold-black mb-4">Attiva l’offerta Serena Gas</h2>
          </template>
          <template v-else-if="utilityType == 'Electricity'">
            <h2 class="h3-semibold-black mb-4">Attiva l’offerta Serena Luce</h2>
          </template>
          <template v-else>
            <h2 class="h3-semibold-black mb-4">Attiva l’offerta Serena Luce + Gas</h2>
          </template>

          <b-row align-v="center"  align-h="center">
            <b-col lg="6" v-for="(r, k) in localOptions.rate" :key="k">
              <div class="box-rata mb-4">
                <div class="h3-regular-white text-center">La tua rata <b>Serena</b></div>
                <div class="rata">
                  <div class="text-center">
                    <template v-if="k == 'Gas'">
                      <i class="icon icon-white mb-1 sgri-gas"></i>
                      <div class="small-text-azure text-white">Gas</div>
                    </template>
                    <template v-else-if="k == 'Electricity'">
                      <i class="icon icon-white mb-1 sgri-luce"></i>
                      <div class="small-text-azure text-white">Luce</div>
                    </template>
                  </div>
                  <div>
                    <div class="big-text-yallow">{{ r.Amount }} €</div>
                    <div class="h4-regular-white">al mese, per 12 mesi!</div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <p class="p-medium-gray-600 mb-4" v-if="isNewCustomer">Compila il form, un nostro commerciale ti contatterà il prima possibile per
            attivare l’offerta Serena con la tua rata fissa.</p>
          <p class="p-medium-gray-600 mb-4" v-if="!isNewCustomer">Compila il form con i tuoi dati per completare la richiesta di attivazione.
            <br>Ti contatteremo nel caso ci fosse necessità.</p>

          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form @submit.stop.prevent="handleSubmit(sendForm)">
              <div class="row">
                <div class="col-md-6">
                  <validation-provider
                      name="Nome"
                      :rules="{ required: true, min: 3 }"
                      v-slot="validationContext"
                  >
                    <div class="form-group">
                      <b-form-input v-model="customer.firstname" type="text" class="form-control form-control-gray-900"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="input-1-live-feedback"
                                    placeholder="Nome *"></b-form-input>
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                          validationContext.errors[0]
                        }}
                      </b-form-invalid-feedback>
                    </div>
                  </validation-provider>
                </div>
                <div class="col-md-6">
                  <validation-provider
                      name="Cognome"
                      :rules="{ required: true, min: 3 }"
                      v-slot="validationContext"
                  >
                    <div class="form-group">
                      <b-form-input v-model="customer.lastname" type="text" class="form-control form-control-gray-900"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="input-2-live-feedback"
                                    placeholder="Cognome *" required></b-form-input>
                      <b-form-invalid-feedback id="input-2-live-feedback">{{
                          validationContext.errors[0]
                        }}
                      </b-form-invalid-feedback>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <label>Come preferisci essere contattato?</label>
              <div class="row">
                <div class="col-lg-12">
                  <b-form-group>
                    <b-input-group>
                      <b-form-select v-model="customer.contactType" :options="contactOptions"
                                     :class="{isPlaceholder: customer.contactType == null}"
                                     class="form-control form-control-gray-900" required>
                        <template #first>
                          <b-form-select-option :value="null" disabled>Preferisco essere contattato tramite...*
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                </div>

                <div class="col-lg-12">
                  <template v-if="customer.contactType=='email'">
                    <p class="p-medium-gray-600 mb-1">Inserisci la tua mail.</p>
                    <validation-provider
                        name="Email"
                        :rules="{ required: true, min: 3, email: true }"
                        v-slot="validationContext"
                    >
                      <b-form-group>
                        <b-input-group>
                          <b-form-input v-model="customer.email" type="email" class="form-control form-control-gray-900"
                                        :state="getValidationState(validationContext)"
                                        aria-describedby="input-email-live-feedback"
                                        placeholder="Email *" required></b-form-input>
                        </b-input-group>
                        <b-form-invalid-feedback id="input-email-live-feedback">{{
                            validationContext.errors[0]
                          }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </template>

                  <template v-else-if="customer.contactType=='phone'">
                    <p class="p-medium-gray-600 mb-1">Inserisci il tuo recapito telefonico.</p>
                    <validation-provider
                        name="Telefono"
                        :rules="{ required: true, min: 6 }"
                        v-slot="validationContext"
                    >
                      <b-form-group>
                        <b-input-group>
                          <b-form-input v-model="customer.phone" type="tel" class="form-control form-control-gray-900"
                                        :state="getValidationState(validationContext)"
                                        aria-describedby="input-telefono-live-feedback"
                                        placeholder="Telefono *" required></b-form-input>
                        </b-input-group>
                        <b-form-invalid-feedback id="input-telefono-live-feedback">{{
                            validationContext.errors[0]
                          }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </template>

                </div>
              </div>

              <b-form-group class="form-check" :state="stateCheck">
                <input type="checkbox" v-model="customer.privacy" :value="true" class="form-check-input"
                       id="privacyCheck"
                       required>
                <label class="form-check-label h8-regular-black" for="privacyCheck">
                  Acconsento al trattamento dei miei dati personali. Consulta la <a href="https://www.asteaenergia.it/privacy-policy/" class="h8-regular-azure-underline" target="_blank">Privacy Policy</a>.</label>
              </b-form-group>
              <button type="submit" class="button-azure-rounded full-width" :disabled="formDisabled">
                INVIA
              </button>
              <p class="mt-2 text-right"><small>* campi obbligatori</small></p>
              <recaptcha-notice />
            </b-form>
          </validation-observer>

        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import { RECAPTCHA_ACTIONS, getRecaptchaToken } from '@/config/recaptcha';
import RecaptchaNotice from '@/components/RecaptchaNoticeComponent';

export default {
  name: 'FormAttivaOfferta',
  components: {RecaptchaNotice},
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    today.setDate(today.getDate() + 1)
    return {
      minDate: today,
      localOptions: null,
      webPath: process.env.VUE_APP_WEB_PATH,

      contactOptions: [
        {value: 'email', text: 'Email'},
        {value: 'phone', text: 'Telefono'},
      ],
      isNewCustomer: null,
      customer: {
        firstname: '',
        lastname: '',
        contactType: null,
        email: '',
        phone: '',
        privacy: null,
        city: null
      }
    }
  },
  props: {
    options: {
      type: [Array, Object],
      required: true
    },
    utilityType: {
      type: String,
      required: true
    }
  },
  computed: {
    rata() {
      let rata = '';
      switch (this.utilityType) {
        case 'Gas':
          rata = this.localOptions.rate.Gas;
          break;
        case 'Electricity':
          rata = this.localOptions.rate.Electricity;
          break;
        case 'Dual':
          rata = {
            Electricity: {
              Amount: this.localOptions.rate.Electricity.Amount
            },
            Gas: {
              Amount: this.localOptions.rate.Gas.Amount
            },
            Amount: (this.localOptions.rate.Electricity.Amount * 1) + (this.localOptions.rate.Gas.Amount * 1)
          };
          break;
      }
      return rata;
    },
    formDisabled() {
      return (this.customer.firstname != null && this.customer.firstname.length < 1)
          || (this.customer.lastname != null && this.customer.lastname.length < 1)
          || (this.customer.contactType == 'email' && this.customer.email != null && this.customer.email.length < 1)
          || (this.customer.contactType == 'phone' && (this.customer.phone != null && this.customer.phone.length < 1))
          || !this.customer.privacy
    },
    stateCheck: function () {
      return this.customer.privacy;
    }
  },
  created() {
    this.$root.footer = false;
    this.localOptions = this._.cloneDeep(this.options);

    if (!this._.isEmpty(this.localOptions.cliente)) {
      this.customer.firstname = this.localOptions.cliente.FirstName;
      this.customer.lastname = this.localOptions.cliente.LastName;
      this.customer.email = this.localOptions.cliente.Email;
      this.customer.phone = this.localOptions.cliente.Mobile;
    }
    this.isNewCustomer = !this.localOptions.seiCliente;

    this.customer.city = this.localOptions.comune;

    if(typeof window.fbq != 'undefined') {
      this.trackFbViewContent('configuratore_serena', 'step-attiva-offerta');
    }
  },
  methods: {
    getValidationState({dirty, validated, valid = null}) {
      return dirty || validated ? valid : null;
    },
    async sendForm() {
      let that = this;
      if (!that.customer.privacy) return false;
      that.$root.loading = true;

      let consumoEE = -1, consumoGM = -1;
      let amountEE = -1, amountGM = -1;
      let power = -1, residential = -1;
      if (typeof that.localOptions.rate.Electricity !== 'undefined' && that.localOptions.rate.Electricity !== null) {
        consumoEE = that.localOptions.rate.Electricity.Consumption;
        amountEE = that.localOptions.rate.Electricity.Amount;
        power = that.localOptions.rate.Electricity.PowerCommitted;
        residential = that.localOptions.rate.Electricity.Resident;
      }
      if (typeof that.localOptions.rate.Gas !== 'undefined' && that.localOptions.rate.Gas !== null) {
        consumoGM = that.localOptions.rate.Gas.Consumption;
        amountGM = that.localOptions.rate.Gas.Amount;
      }

      let params = {
        customer: {
          Firstname: that.customer.firstname,
          Lastname: that.customer.lastname,
          Type: that.customer.contactType,
          Email: that.customer.email,
          Phone: that.customer.phone,
          City: that.customer.city,
        },
        offer: {
          NewCustomer: !that.localOptions.seiCliente,
          Amount: that.rata.Amount,
          AmountEE: amountEE,
          AmountGM: amountGM,
          Power: power,
          Residential: residential,
          ISTATCode: that.localOptions.comune.istat,
          ConsumptionEE: consumoEE,
          ConsumptionGM: consumoGM
        }
      }

      if( typeof this.localOptions.wizard !== 'undefined')
        params.wizard = this.localOptions.wizard;

      if( typeof this.localOptions.cliente !== 'undefined' && this.localOptions.cliente !== null && typeof this.localOptions.cliente.FiscalCode !== 'undefined' && this.localOptions.cliente.FiscalCode !== null)
        params.customer.FiscalCode = this.localOptions.cliente.FiscalCode;

      if( typeof this.localOptions.cliente !== 'undefined' && this.localOptions.cliente !== null && typeof this.localOptions.cliente.ContractNumber !== 'undefined' && this.localOptions.cliente.ContractNumber !== null)
        params.customer.ContractNumber = this.localOptions.cliente.ContractNumber;

      params.recaptcha_action = RECAPTCHA_ACTIONS.ACTIVATION_OFFER;
      params.recaptcha_token = await getRecaptchaToken(RECAPTCHA_ACTIONS.ACTIVATION_OFFER);

      that.axios.post(that.webPath + 'wp-admin/admin-ajax.php?action=relax_activation_offer', params)
          .then((response) => {
            let data = that.decryptAES(response.data);
            if ((typeof data.error !== 'undefined' && data.error) || !data.success) {
              that.showAlertModal(data.message)
              that.$root.loading = false;
            } else if (data.success) {
              if(typeof window.fbq != 'undefined') {
                this.trackFbPurchase('configuratore_serena', 'attiva-offerta-' + data.nameOffer, that.rata.Amount);
              }
              if (typeof window.gtag !== 'undefined') {
                window.gtag('event', 'contatto', { 'event_category': 'configuratore-serena', 'event_label': 'attiva-offerta-' + data.nameOffer });
              }
              setTimeout(() => {
                that.$router.push({name: 'message-sent', params: {type: 'attiva-offerta'}});
              }, 1000);
            }
          })
          .catch((error) => {
            this.captureExceptionSentry(error);
            let message = "Qualcosa è andato storto, riprovare più tardi."
            this.showAlertModal(message)
            this.$root.loading = false;
          })
    }
  },
}
</script>

<style scoped lang="scss">
button[type=submit] {
  font-size: 16px;
}
</style>
